import React from "react";
import ImportCell from "./renderCell";

const ImportRow = ({ row, index, errors, duplicates, modifyValue }) => {
  return (
    <tr style={{ backgroundColor: duplicates ? "#FFFFE0" : null }}>
      <th>{parseInt(index) + 1}</th>
      {row.map((cell, index) => (
        <ImportCell
          key={`${cell}-${index}`}
          value={cell}
          valid={errors ? !errors[index] : true}
          modifyValue={(value) => modifyValue(value, index)}
        />
      ))}
    </tr>
  );
};

export default React.memo(ImportRow);
